import HttpResponse from "../../../../../utils/http/http.response";

export enum OrderCancelOrderNotAcceptableResponseErrorType {
  ORDER_CANCELLED = "ORDER_CANCELLED",
  PASSENGER_ON_BOARD = "PASSENGER_ON_BOARD",
}

export type OrderCancelOrderNotAcceptableResponseOrderCancelledError = {
  errorType: OrderCancelOrderNotAcceptableResponseErrorType.ORDER_CANCELLED;
};

export type OrderCancelOrderNotAcceptableResponsePassengerOnboardError = {
  errorType: OrderCancelOrderNotAcceptableResponseErrorType.PASSENGER_ON_BOARD;
};

export type OrderCancelOrderNotAcceptableResponseError =
  | OrderCancelOrderNotAcceptableResponseOrderCancelledError
  | OrderCancelOrderNotAcceptableResponsePassengerOnboardError;

type OrderCancelOrderSuccessResponse = HttpResponse<string>;

export type OrderCancelOrderNotAcceptableResponse =
  HttpResponse<OrderCancelOrderNotAcceptableResponseError>;

type OrderCancelOrderResponse =
  | OrderCancelOrderSuccessResponse
  | OrderCancelOrderNotAcceptableResponse;

export default OrderCancelOrderResponse;
